import React, {useEffect, useRef, useState} from 'react'
import {confirm} from 'react-confirm-box'
import {useDispatch, useSelector} from 'react-redux'
import {
  getOurTemplateList,
  getAllCategoryList,
  getOurTemplate,
} from '../../../MyTemplate/OurTemplates/OurTemplateSlice/OurTemplateSlice'
import TemplatePreviewPopup from '../Modal/TemplatePreviewPopup'
import {getTemplateListWithoutPagination} from '../../../MyTemplate/CreateScratch/CreateScratchSlices/CreateScratchSlices'
import {
  BulkMsgDraftData,
} from '../../BulkMessageSlice/BulkMessageSlice'
import ConfirmationModel from '../../../../../Components/ConfirmationModel'
import {bulkMessageState} from '../NewMessageStepper'
import Select from 'react-select'
import CampaignSearchSelect from './CampaignSearchSelect'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {processLinks} from '../../../../../Utils/_helpers'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
import {useNewMessage} from '../../useNewMessage'
import moment from 'moment-timezone'

const GettingStartedV2 = ({
  setBulkMessageData,
  bulkMessageData,
  FirstDiv,
  error,
  setError,
  checkStep,
  setCheckStep,
  setIsForwardIncomingMessage,
}: any) => {
  const dispatch = useDispatch()
  ////////////COnfirmation state//////////////////
  const [confirmationPopup, setConfirmationPopup] = useState(false)
  const [message, setMessage] = useState('')
  const [allow, setAllow] = useState(false)
  ////////////////////////////////////////////////
  const [visible, setVisble] = useState(false)
  const [showTemplate, setShowTemplate] = useState(false)
  // const [savedCampaignsId, setSavedCampaignsId] = useState()
  const [activeTab, setActiveTab] = useState('newCamp')
  const [filterName, setFilterName] = useState<any>({type: 'MMS'})
  const [templateData, setTemplateData] = useState({})
  const Templates: [] = useSelector(getOurTemplateList)
  const Category = useSelector(getAllCategoryList)
  // const templates: any = useSelector(getTemplateList)
  const templates: any = useSelector(getTemplateListWithoutPagination)
  const {isDefaultRegion} = useNewMessage()

  const MMSList = Templates?.filter((key: any) => key?.type == 'MMS')
  const SMSList = Templates?.filter((key: any) => key?.type == 'SMS')
  const selectTemplateRef: any = useRef()
  useEffect(() => {
    dispatch(getOurTemplate(filterName))
  }, [filterName])
  useEffect(() => {
    if (allow == true) {
      setBulkMessageData(bulkMessageState)
      setAllow(false)
      setError({})
    }
  }, [allow])

  const cleanOptOutFromMessage = (message: string) => {
    let pattern = ENV().REACT_APP_OPTOUT
    if (!pattern) {
      return message
    }

    // Create a regular expression pattern dynamically
    const urlPattern = new RegExp(`${pattern}/\\S*`, 'g')

    // Remove the matching URL
    let cleanedMessage = message.replace(urlPattern, '')

    // Remove double (or more) line breaks
    cleanedMessage = cleanedMessage.replace(/\n{2,}/g, '\n')

    // Trim any leading or trailing whitespace or line breaks

    return cleanedMessage.trim()
  }

  const decodeLandingPageUrl = (message: string) => {
    let pattern = ENV().REACT_APP_SHORTURL
    if (!pattern) {
      return message
    }

    // Define a regular expression to match URLs in the format 'dev.gosite.au/luvg1aE'
    const urlPattern = new RegExp(`(${pattern}/l\\w*)`, 'g')

    // Replace matched URL codes that start with "l" with "Lxxxxx"
    const cleanedMessage = message.replace(urlPattern, `${pattern}/Lxxxxx`)

    return cleanedMessage
  }

  const handleSavedCampaign = (selectedCampaign: any) => {
    if (!selectedCampaign?.value) {
      setBulkMessageData(bulkMessageState)
      setError({})
      return
    }

    const campaignSource = selectedCampaign?.source
    const campaignData = selectedCampaign?.data

    if (campaignSource === 'saved' && campaignData) {
      const name = {...campaignData}
      if (name) {
        if (name && name.optout && name.optout === true) {
          name.message = name.message.replace('\nSTOP: stoptxt.au/vc', '')
          name.message = cleanOptOutFromMessage(name.message)
        }

        if (name && name.replyStopToOptOut && name.replyStopToOptOut === true) {
          name.message = name.message.replace("\nReply 'STOP' to opt-out", '')
        }

        setBulkMessageData({
          ...name,
          saveCampaignId: selectedCampaign,
          media: name?.media?.url,
          urlData: name?.media,
          senderType: name?.senderType ? name?.senderType : '',
          sender: name?.sender
            ? {value: name?.sender, label: `${name?.sender}-${name?.camp_type?.toUpperCase()}`}
            : '',
          selectedTemplate: bulkMessageData?.selectedTemplate
            ? bulkMessageData?.selectedTemplate
            : {value: '', label: 'Select Template'},
          message: processLinks(name?.message),
          forwardReplyTo: name?.forwardReplyTo ? name.forwardReplyTo : '',
          previouslySendId: selectedCampaign,
        })
        setError({})

        if (name?.forwardReplyTo) {
          setIsForwardIncomingMessage(true)
        }
        // validation({saveCampaignId: val, ...name})
      } else {
        setBulkMessageData(bulkMessageState)
        setError({})
      }
    } else {
      const data = campaignData

      let cleanMessage = cleanOptOutFromMessage(processLinks(data?.message))
      if (data?.landingPageId && data?.landingPageId !== '') {
        cleanMessage = decodeLandingPageUrl(cleanMessage)
      }
      setBulkMessageData({
        ...data,
        media: data?.media?.[0]?.url,
        urlData: data?.media?.[0],
        previouslySendId: selectedCampaign,
        senderType: data?.senderType ? data?.senderType : '',
        sender: data?.sender
          ? data?.senderType == '#SharedNum#'
            ? {value: '#SharedNum#', label: '#SharedNum#'}
            : {value: data?.sender, label: data?.sender}
          : '',
        selectedTemplate: {value: '', label: 'Select Template'},
        message: cleanMessage,
      })
    }
  }
  const handleSelectTemplate = (e: any) => {
    const preveiousTemplate = templates?.find((key: any) => key.name == e.value)
    setBulkMessageData({
      ...bulkMessageData,
      message: preveiousTemplate.message,
      camp_type: preveiousTemplate.type?.toLowerCase(),
      media: preveiousTemplate.media,
      gif: preveiousTemplate.gif,
      subject: preveiousTemplate.subjectTitle,
      selectedTemplate: e,
    })
  }

  const optionsWithLabelChange = {
    closeOnOverlayClick: false,
    labels: {
      confirmable: 'Confirm',
      cancellable: 'Cancel',
    },
  }

  const getSubtitle = (): string => {
    if (bulkMessageData?.name !== '') {
      return activeTab == 'newCamp' ? 'New campaign' : 'Saved campaign'
    } else {
      return 'Name your campaign and choose its type.'
    }
  }

  const getHeaderTitleDetail = (): string => {
    if (bulkMessageData?.name !== '') {
      return bulkMessageData?.name
    } else {
      return 'Your campaign type'
    }
  }

  return (
    <>
      <ConfirmationModel
        show={confirmationPopup}
        handleClose={() => setConfirmationPopup(false)}
        message={message}
        setAllow={setAllow}
      />
      <TemplatePreviewPopup
        show={visible}
        handleClose={() => setVisble(false)}
        templateData={templateData}
        setBulkMessageData={setBulkMessageData}
        bulkMessageData={bulkMessageData}
      />
      <h2
        className={`accordion-header ${bulkMessageData.name !== '' && 'successData'}`}
        id='headingOne'
      >
        <button
          ref={FirstDiv}
          className='accordion-button successComplete'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseOne'
          aria-expanded='true'
          aria-controls='collapseOne'
          onClick={() => {
            setCheckStep({
              gettingStarted: !checkStep.gettingStarted,
              to: false,
              from: false,
              message: false,
              when: false,
            })
          }}
        >
          <div className='d-flex flex-column align-items-start gap-1'>
            <span className={checkStep.gettingStarted ? 'text-primary' : ''}>Getting started</span>
            <span className='accordion-subtitle fs-6 fw-normal lh-base'>{getSubtitle()}</span>
          </div>
        </button>
        <div className='bulk-message-collapse'>
          <div
            className='accordion-title-detail small'
            data-testid='txtNewCampaign'
            style={{
              color: `${bulkMessageData.name !== '' ? '#1A1C37' : ''}`,
              maxWidth: '200px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {getHeaderTitleDetail()}
          </div>
        </div>
      </h2>
      <div
        id='collapseOne'
        className={`accordion-collapse collapse  ${checkStep.gettingStarted && 'show'}`}
        aria-labelledby='headingOne'
        data-bs-parent='#accordionExample'
      >
        <div className='accordion-body'>
          <ul className='nav nav-tabs' id='myTab' role='tablist'>
            <li className='nav-item mb-3 me-3' role='presentation'>
              <button
                className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${
                  activeTab == 'newCamp' ? 'active' : ''
                }`}
                data-testid='btnNewCampaign'
                onClick={async () => {
                  if (bulkMessageData?.name !== '') {
                    let confirNew = await confirm(
                      'Are you sure you want to create a new campaign?',
                      optionsWithLabelChange
                    )

                    if (confirNew) {
                      setBulkMessageData(bulkMessageState)
                      setError({})
                      setActiveTab('newCamp')
                    } else {
                      setActiveTab('pervCamp')
                    }
                  } else {
                    setActiveTab('newCamp')
                  }
                }}
              >
                New campaign
              </button>
            </li>
            <li className='nav-item mb-3 me-3' role='presentation'>
              <button
                className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${
                  activeTab == 'pervCamp' ? 'active' : ''
                } ${!isDefaultRegion && 'd-none'}`}
                onClick={async () => {
                  if (bulkMessageData?.name !== '') {
                    let confirNew = await confirm(
                      'Are you sure you want to use saved campaign?',
                      optionsWithLabelChange
                    )

                    if (confirNew) {
                      setBulkMessageData(bulkMessageState)
                      setError({})
                      setActiveTab('pervCamp')
                    } else {
                      setActiveTab('newCamp')
                    }
                  } else {
                    setActiveTab('pervCamp')
                  }
                }}
                data-testid='btnSavedCampaigns'
                disabled={!isDefaultRegion}
              >
                Saved campaign
              </button>
            </li>
          </ul>
          <div className='tab-content' id='myTabContent'>
            <div
              className={`tab-pane fade   ${activeTab == 'newCamp' ? 'show active' : ''} `}
              id='Newcampaign'
              role='tabpanel'
              aria-labelledby='New-campaign-tab'
            >
              <label className='mb-2' data-testid='txtCampaignTitle'>
                Campaign title
              </label>
              <div className='mxw_474'>
                <input
                  type='text'
                  data-testid='inputNewCampaignTitle'
                  className='form-control form-control-lg form-control-solid w-100 react-tagsinput-input'
                  placeholder='Type a catchy campaign name'
                  value={bulkMessageData.name}
                  onChange={(e: any) => {
                    let errorData = {...error}

                    delete errorData.name

                    setBulkMessageData({...bulkMessageData, name: e.target.value})
                    dispatch(
                      BulkMsgDraftData({
                        ...bulkMessageData,
                        scheduledAt: '',
                        name: e.target.value,
                      })
                    )

                    e.target.value !== ''
                      ? setError(errorData)
                      : setError({...error, name: 'name is required'})
                  }}
                />
              </div>
            </div>
            <div
              className={`tab-pane fade   ${activeTab == 'pervCamp' ? 'show active' : ''} ${
                !isDefaultRegion && 'd-none'
              }`}
              id='Previously-campaigs'
              role='tabpanel'
              aria-labelledby='Previously-campaigs'
            >
              <label className='mb-2' data-testid='labelSavedCampaigns'>
                Saved campaign
              </label>

              <CampaignSearchSelect
                data-testid='ddSavedCampaign'
                value={bulkMessageData?.previouslySendId || null}
                placeholder='Select saved campaign'
                className='mw-xl-75'
                onChange={handleSavedCampaign}
              />
            </div>

            {/* //////OUR TEMPLATE//// */}
            <div
              className='fade tab-pane'
              id='Templates'
              role='tabpanel'
              aria-labelledby='Templates-tab'
            >
              <label className='mb-2'>Saved campaigns</label>
              <div className='d-flex flex-column flex-sm-row align-items-sm-center align-items-start'>
                <Select
                  value={bulkMessageData?.selectedTemplate}
                  onChange={handleSelectTemplate}
                  name='selector'
                  className='form-select bg-light-primary border-0 mw-xl-75 py-4'
                  options={templates?.items?.map((key: any) => ({
                    value: key?.name,
                    label: key?.name,
                  }))}
                />
                <button
                  onClick={() => setShowTemplate(!showTemplate)}
                  className='btn btn-primary p-4 text-nowrap msg-primary-btn mx-2 px-7'
                >
                  {`${showTemplate ? 'Hide our templates' : 'view our templates'} `}
                </button>
              </div>

              {showTemplate && (
                <div className='row template-sidebar-main'>
                  <div className='col-md-3 col-sm-4'>
                    <div className='template-sidebar'>
                      <div className='sidebar-block'>
                        <span className='title'>TYPE</span>
                        <ul>
                          <li
                            className='cursor-pointer'
                            onClick={() => setFilterName({type: 'MMS'})}
                          >
                            MMS
                          </li>
                          <li
                            className='cursor-pointer'
                            onClick={() => setFilterName({type: 'SMS'})}
                          >
                            SMS
                          </li>
                        </ul>
                      </div>

                      <div className='sidebar-block'>
                        <span className='title'>Category</span>
                        <ul>
                          {Category?.data?.category?.map((val: any, i: number) => (
                            <li
                              key={i}
                              className='row cursor-pointer'
                              onClick={() => setFilterName({category: val?._id})}
                            >
                              <p className='col-10'>{val._id?.toUpperCase()}</p>
                              <span className='col-2'>{val?.total}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className='sidebar-block'>
                        <span className='title'>Industry</span>
                        <ul>
                          {Category?.data?.industry?.map((val: any, i: number) => (
                            <li
                              key={i}
                              className='row cursor-pointer'
                              onClick={() => setFilterName({industry: val?._id})}
                            >
                              <p className='col-10'>{val._id?.toUpperCase()}</p>
                              <span className='col-2'>{val?.total}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-9 col-sm-8 ps-sm-10'>
                    <div className='template-block-main'>
                      <div className='template-block-title'>
                        <strong>
                          {filterName?.type || filterName?.industry || filterName?.category}
                        </strong>
                      </div>

                      <div className='row mx-n6 template-row'>
                        {MMSList?.length !== 0 && (
                          <>
                            {Templates?.map((key: any, index: number) => {
                              return (
                                <React.Fragment key={index}>
                                  {key.type == 'MMS' && (
                                    <div key={key?._id} className='col-md-6 px-6'>
                                      <div className='template-block'>
                                        <img
                                          alt='Logo'
                                          src={key?.media}
                                          className='border-10 rounded w-100 img-fluid'
                                        />
                                        <div className='template-block-desc'>
                                          <ul className='type'>
                                            {key?.tags?.map((tags: any, i: number) => (
                                              <a
                                                key={i}
                                                className={'badge badge-light-primary me-2 mb-2'}
                                              >
                                                {tags}
                                              </a>
                                            ))}
                                          </ul>
                                          <p className='user-title'>{key?.message}</p>
                                          <div className='preview'>
                                            <div className='pre-total'>
                                              <img
                                                src={toAbsoluteUrl('/media/mobile/calandar.svg')}
                                                alt='Calander'
                                              />
                                              {key?.message?.split('')?.length}
                                            </div>
                                            <div className='pre-btn'>
                                              <span
                                                onClick={() => {
                                                  setVisble(true)
                                                  setTemplateData(key)
                                                }}
                                                className='btn btn-primary msg-primary-btn'
                                              >
                                                Preview
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </React.Fragment>
                              )
                            })}
                          </>
                        )}

                        {SMSList?.length !== 0 && (
                          <>
                            <h1 className='d-flex justify-content-start fw-bolder'>SMS</h1>
                            {Templates?.map((key: any, index: number) => {
                              return (
                                <React.Fragment key={index}>
                                  {key.type == 'SMS' && (
                                    <div key={key?._id} className='col-md-6 px-6'>
                                      <div className='template-block'>
                                        <div className='template-block-desc'>
                                          <ul className='type'>
                                            {key?.tags?.map((tags: any, i: number) => (
                                              <a
                                                key={i}
                                                className={'badge badge-light-primary me-2 mb-2'}
                                              >
                                                {tags}
                                              </a>
                                            ))}
                                          </ul>
                                          <p className='user-title'>{key?.message}</p>
                                          <div className='preview'>
                                            <div className='pre-total'>
                                              <img
                                                src='/Cellcast-reactjs/media/mobile/calandar.svg'
                                                alt='preview'
                                              />
                                              {key?.content?.split('')?.length}
                                            </div>
                                            <div className='pre-btn'>
                                              <span
                                                onClick={() => {
                                                  setVisble(true)
                                                  setTemplateData(key)
                                                }}
                                                className='btn btn-primary msg-primary-btn'
                                              >
                                                Preview
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </React.Fragment>
                              )
                            })}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default GettingStartedV2
